// material-ui

import shipmentmoveblicon from '../../../assets/images/shipment-move-bl.svg';
/**
 * if you want to use image instead of <svg> uncomment following.
 *
 * import logoDark from 'assets/images/logo-dark.svg';
 * import logo from 'assets/images/logo.svg';
 *
 */

// ==============================|| LOGO SVG ||============================== //

const ShipmentMoveBlIcon = () => {
    

    return (
        /**
         * if you want to use image instead of svg uncomment following, and comment out <svg> element.
         *
         * <img src={logo} alt="Berry" width="100" />
         *
         */
         <img src={shipmentmoveblicon} alt="Shipment Movements" width="22"  />
    );
};

export default ShipmentMoveBlIcon;


